import { useEffect, useState } from "react";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import "./EventOverviewPage.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { UpdateEventDto } from "../../models/Event";
import {
  CalendarOutlined,
  CarryOutOutlined,
  FundProjectionScreenOutlined,
  HomeOutlined,
  SoundOutlined,
  TeamOutlined,
  UserOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import { Button, Progress, Spin, Tooltip } from "antd";
import { UpdateAccommodationDto } from "../../models/Accommodation";
import { UpdateEventXRoomTypeCreate } from "../../models/EventXRoomTypeDto";
import { RoomKindDto } from "../../models/RoomKind";
import useFetchOneEvent from "../../customHooks/FetchOneEvent/FetchOneEvent";

const EventOverviewPage = () => {
  const { setBreadcrumb, state, setReload } = useApplicationContext();
  const { id } = useParams();
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [oneEvent, setOneEvent] = useState<UpdateEventDto>();
  const navigate = useNavigate();
  const [data] = useFetchOneEvent(id);

  useEffect(() => {
    setActiveSpinner(true);
    if (id !== undefined) {
      setActiveSpinner(true);
      setBreadcrumb(["Događaji", data?.name]);
      setOneEvent(data);
      if (data?.name) {
        setActiveSpinner(false);
      }
      setReload(false);
    }
  }, [state.reload, data]);

  return (
    <PageLayout>
      <Spin spinning={activeSpinner}>
        <div className="event-overview">
          <div className="row-ep">
            <div className="title-row">
              <h4>Opšte informacije o događaju</h4>
              <div>
                <div className="first-column-f">
                  <p>Legenda:</p>
                  <span style={{ color: "#52C41A" }}>
                    {" "}
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.7418 10C11.7418 10.1182 11.7185 10.2352 11.6733 10.3444C11.6281 10.4536 11.5618 10.5528 11.4782 10.6364C11.3946 10.72 11.2954 10.7863 11.1862 10.8315C11.077 10.8767 10.96 10.9 10.8418 10.9C10.7236 10.9 10.6066 10.8767 10.4974 10.8315C10.3882 10.7863 10.289 10.72 10.2054 10.6364C10.1219 10.5528 10.0556 10.4536 10.0103 10.3444C9.9651 10.2352 9.94182 10.1182 9.94182 10C9.94182 9.76133 10.0366 9.53241 10.2054 9.36363C10.3742 9.19484 10.6031 9.10002 10.8418 9.10002C11.0805 9.10002 11.3094 9.19484 11.4782 9.36363C11.647 9.53241 11.7418 9.76133 11.7418 10ZM8.28342 0.416822C8.19601 0.398047 8.10551 0.399043 8.01854 0.419738C7.93156 0.440432 7.85031 0.480301 7.78073 0.536431C7.71114 0.592561 7.65497 0.663532 7.61634 0.744156C7.5777 0.82478 7.55757 0.913019 7.55742 1.00242V19.0024C7.5574 19.0919 7.57739 19.1803 7.61595 19.2611C7.65451 19.3418 7.71065 19.413 7.78026 19.4692C7.84987 19.5255 7.93118 19.5655 8.01825 19.5862C8.10531 19.607 8.19591 19.608 8.28342 19.5892L16.6834 17.788C16.8176 17.7589 16.9378 17.6847 17.0238 17.5776C17.1099 17.4706 17.1566 17.3373 17.1562 17.2V2.80002C17.156 2.66295 17.1088 2.53009 17.0226 2.42355C16.9364 2.31701 16.8162 2.24321 16.6822 2.21442L8.28222 0.415622L8.28342 0.416822ZM8.75742 18.2596V1.74402L15.9574 3.28602V16.7164L8.75742 18.2596ZM6.35982 18.3976V17.1976H1.55742V2.80362H6.35982V1.60362H0.957422C0.798292 1.60362 0.64568 1.66684 0.533158 1.77936C0.420636 1.89188 0.357422 2.04449 0.357422 2.20362V17.7976C0.357422 17.9568 0.420636 18.1094 0.533158 18.2219C0.64568 18.3344 0.798292 18.3976 0.957422 18.3976H6.35982Z"
                        fill="#52C41A"
                      />
                    </svg>
                    Slobodno{" "}
                  </span>
                  <span style={{ color: "#FABC29" }}>
                  <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5543 12C15.5543 12.1182 15.531 12.2352 15.4858 12.3444C15.4406 12.4536 15.3743 12.5528 15.2907 12.6364C15.2071 12.72 15.1079 12.7863 14.9987 12.8315C14.8895 12.8767 14.7725 12.9 14.6543 12.9C14.5361 12.9 14.4191 12.8767 14.3099 12.8315C14.2007 12.7863 14.1015 12.72 14.0179 12.6364C13.9344 12.5528 13.8681 12.4536 13.8228 12.3444C13.7776 12.2352 13.7543 12.1182 13.7543 12C13.7543 11.7613 13.8491 11.5324 14.0179 11.3636C14.1867 11.1948 14.4156 11.1 14.6543 11.1C14.893 11.1 15.1219 11.1948 15.2907 11.3636C15.4595 11.5324 15.5543 11.7613 15.5543 12ZM12.0959 2.41682C12.0085 2.39805 11.918 2.39904 11.831 2.41974C11.7441 2.44043 11.6628 2.4803 11.5932 2.53643C11.5236 2.59256 11.4675 2.66353 11.4288 2.74416C11.3902 2.82478 11.3701 2.91302 11.3699 3.00242V21.0024C11.3699 21.0919 11.3899 21.1803 11.4285 21.2611C11.467 21.3418 11.5231 21.413 11.5928 21.4692C11.6624 21.5255 11.7437 21.5655 11.8307 21.5862C11.9178 21.607 12.0084 21.608 12.0959 21.5892L20.4959 19.788C20.6301 19.7589 20.7503 19.6847 20.8363 19.5776C20.9224 19.4706 20.9691 19.3373 20.9687 19.2V4.80002C20.9685 4.66295 20.9213 4.53009 20.8351 4.42355C20.7489 4.31701 20.6287 4.24321 20.4947 4.21442L12.0947 2.41562L12.0959 2.41682ZM12.5699 20.2596V3.74402L19.7699 5.28602V18.7164L12.5699 20.2596ZM10.1723 20.3976V19.1976H5.36992V4.80362H10.1723V3.60362H4.76992C4.61079 3.60362 4.45818 3.66684 4.34566 3.77936C4.23314 3.89188 4.16992 4.04449 4.16992 4.20362V19.7976C4.16992 19.9568 4.23314 20.1094 4.34566 20.2219C4.45818 20.3344 4.61079 20.3976 4.76992 20.3976H10.1723Z"
                        fill="#FABC29"
                      />
                    </svg>
                    Rezervisano
                  </span>
                  <span style={{ color: "#C7363D" }}>
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.3668 10C12.3668 10.1182 12.3435 10.2352 12.2983 10.3444C12.2531 10.4536 12.1868 10.5528 12.1032 10.6364C12.0196 10.72 11.9204 10.7863 11.8112 10.8315C11.702 10.8767 11.585 10.9 11.4668 10.9C11.3486 10.9 11.2316 10.8767 11.1224 10.8315C11.0132 10.7863 10.914 10.72 10.8304 10.6364C10.7469 10.5528 10.6806 10.4536 10.6353 10.3444C10.5901 10.2352 10.5668 10.1182 10.5668 10C10.5668 9.76133 10.6616 9.53241 10.8304 9.36363C10.9992 9.19484 11.2281 9.10002 11.4668 9.10002C11.7055 9.10002 11.9344 9.19484 12.1032 9.36363C12.272 9.53241 12.3668 9.76133 12.3668 10ZM8.90842 0.416822C8.82101 0.398047 8.73051 0.399043 8.64354 0.419738C8.55656 0.440432 8.47531 0.480301 8.40573 0.536431C8.33614 0.592561 8.27997 0.663532 8.24134 0.744156C8.2027 0.82478 8.18257 0.913019 8.18242 1.00242V19.0024C8.1824 19.0919 8.20239 19.1803 8.24095 19.2611C8.27951 19.3418 8.33565 19.413 8.40526 19.4692C8.47487 19.5255 8.55618 19.5655 8.64325 19.5862C8.73031 19.607 8.82091 19.608 8.90842 19.5892L17.3084 17.788C17.4426 17.7589 17.5628 17.6847 17.6488 17.5776C17.7349 17.4706 17.7816 17.3373 17.7812 17.2V2.80002C17.781 2.66295 17.7338 2.53009 17.6476 2.42355C17.5614 2.31701 17.4412 2.24321 17.3072 2.21442L8.90722 0.415622L8.90842 0.416822ZM9.38242 18.2596V1.74402L16.5824 3.28602V16.7164L9.38242 18.2596ZM6.98482 18.3976V17.1976H2.18242V2.80362H6.98482V1.60362H1.58242C1.42329 1.60362 1.27068 1.66684 1.15816 1.77936C1.04564 1.89188 0.982422 2.04449 0.982422 2.20362V17.7976C0.982422 17.9568 1.04564 18.1094 1.15816 18.2219C1.27068 18.3344 1.42329 18.3976 1.58242 18.3976H6.98482Z"
                        fill="#C7363D"
                      />
                    </svg>
                    Popunjeno
                  </span>
                </div>
              </div>
            </div>
            <div className="grid-column">
              <div className="column-ep">
                <div className="icon">
                  <CalendarOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep title-ep-bold">
                    {moment(oneEvent?.dateFrom).format("DD.MM.YYYY")} -{" "}
                    {moment(oneEvent?.dateTo).format("DD.MM.YYYY")}
                  </div>
                  <div className="text-ep">{oneEvent?.place}</div>
                </div>
              </div>
              <div className="column-ep">
                <div className="icon">
                  <SoundOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep">{oneEvent?.name}</div>
                  <div className="text-ep">{oneEvent?.detailName}</div>
                </div>
              </div>
              <div className="column-ep">
                <div className="icon">
                  <CarryOutOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep">{oneEvent?.organizer}</div>
                  <div className="text-ep">
                    {oneEvent?.tags?.map((tags: string) => {
                      return <div className="tags-ep">{`#${tags}`}</div>;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row-ep">
            <div className="title-row">
              <h4>Kongresne informacije</h4>
            </div>
            <div className="grid-column">
              <div className="column-ep">
                <div className="icon">
                  <FundProjectionScreenOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep title-ep-bold">Kongresna sala</div>
                  <div className="text-ep">{oneEvent?.place}</div>
                </div>
              </div>
              <div
                className="column-ep"
                onClick={() => {
                  navigate(
                    `/event-overview/registrationStatus/${oneEvent?.id}/Učesnik`
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="icon">
                  <TeamOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep title-ep-bold">Ukupno učesnika</div>
                  <div className="text-ep">{oneEvent?.participantsCount}</div>
                </div>
              </div>
              <div
                className="column-ep"
                onClick={() => {
                  navigate(
                    `/event-overview/registrationStatus/${oneEvent?.id}/Predavač`
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="icon">
                  <UserSwitchOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep">Ukupno predavača:</div>
                  <div className="text-ep">{oneEvent?.speakerCount}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row-ep">
            <div className="title-row">
              <h4>Učesnici</h4>
            </div>
            <div className="grid-column">
              <div
                className="column-ep"
                onClick={() => {
                  navigate(
                    `/event-overview/registrationStatus/${oneEvent?.id}/Gost`
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="icon">
                  <TeamOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep ">Ukupno gostiju</div>
                  <div className="text-ep title-ep-bold">
                    {oneEvent?.guestCount}
                  </div>
                </div>
              </div>
              <div
                className="column-ep"
                onClick={() => {
                  navigate(
                    `/event-overview/registrationStatus/${oneEvent?.id}/pravnaLica`
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="icon">
                  <HomeOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep">Pravna lica</div>
                  <div className="text-ep">{oneEvent?.legalEntityCount}</div>
                </div>
              </div>
              <div
                className="column-ep"
                onClick={() => {
                  navigate(
                    `/event-overview/registrationStatus/${oneEvent?.id}/fizickaLica`
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="icon">
                  <UserOutlined />
                </div>
                <div className="text-info">
                  <div className="title-ep">Fizička lica</div>
                  <div className="text-ep">{oneEvent?.individualCount}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row-ep">
            <div className="title-row">
              <h4>Smeštaj</h4>
            </div>
            <div className="all-acoommodation">
              {oneEvent?.accommodations?.map(
                (event: UpdateAccommodationDto, i: number) => {
                  // const totalNumber = event?.totalNumberOfRooms;

                  const totalNumber = event?.roomTypes?.reduce(
                    (total: number, roomType: UpdateEventXRoomTypeCreate) =>
                      total + roomType.totalNumber,
                    0
                  );

                  const Full = event?.roomTypes.reduce(
                    (total: number, roomType: UpdateEventXRoomTypeCreate) =>
                      total + roomType.usedNumber,
                    0
                  );

                  const Reserved = event.roomTypes.reduce(
                    (total: number, roomType: UpdateEventXRoomTypeCreate) =>
                      total + roomType.reservedNumber,
                    0
                  );

                  let Free = totalNumber - (Full + Reserved);

                  return (
                    <div
                      className="table-ep"
                      key={i}
                      onClick={() => {
                        navigate(
                          `/accommodation-overview/${oneEvent.id}/${event.id}`,
                          {
                            state: {
                              accommodation: event, /// accommodation
                              event: oneEvent,
                            },
                          }
                        );
                      }}
                    >
                      <div
                        className="header-custom-table"
                        style={{ cursor: "pointer" }}
                      >
                        <span>{event?.name}</span>
                        <span className="last-c">Popunjenost</span>
                        <Button
                          className="view-capacity"
                          type="primary"
                          size={"large"}
                        >
                          Pregled
                        </Button>
                      </div>

                      <div className="custom-table-body">
                        <div className="row-c-t">
                          <span>Kapacitet smeštaja</span>
                          <span className="text-row-2">{totalNumber}</span>
                          <div>
                            <Tooltip
                              className="progress"
                              title={`${Full} Popunjeno / ${Reserved} Rezervisano / ${Free} Slobodno`}
                            >
                              <div className="progress-bar-ep">
                                <Progress
                                  percent={
                                    +(
                                      (Reserved / (Full + Reserved + Free)) *
                                        100 +
                                      (Full / (Full + Reserved + Free)) * 100
                                    ).toFixed(2)
                                  }
                                  success={{
                                    percent:
                                      (Full / (Full + Reserved + Free)) * 100,
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="row-roomType">
                          {event?.roomTypes?.map(
                            (roomType: UpdateEventXRoomTypeCreate) => {
                              let totalNumber = roomType?.totalNumber;
                              let Full = roomType?.usedNumber || 0; /// popunjeno
                              let Reserved = roomType?.reservedNumber || 0; /// rezervisano
                              let Free = totalNumber - (Full + Reserved); /// slobodno

                              return (
                                <div className="row-c-t">
                                  <span className="text-row">
                                    {roomType?.name}
                                  </span>
                                  <span className="text-row-2">
                                    <p style={{ color: "#C7363D" }}>{Full}/</p>
                                    <p style={{ color: "#FABC29" }}>
                                      {Reserved}/
                                    </p>
                                    <p style={{ color: "#52C41A" }}>{Free}</p>
                                  </span>
                                  <div>
                                    <Tooltip
                                      className="progress"
                                      title={`${Full} Popunjeno / ${Reserved} Rezervisano / ${Free} Slobodno`}
                                    >
                                      <div className="progress-bar-ep">
                                        <Progress
                                          percent={
                                            +(
                                              (Reserved /
                                                (Full + Reserved + Free)) *
                                                100 +
                                              (Full /
                                                (Full + Reserved + Free)) *
                                                100
                                            ).toFixed(2)
                                          }
                                          success={{
                                            percent:
                                              (Full /
                                                (Full + Reserved + Free)) *
                                              100,
                                          }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>

            {/* --------------------------------------------------- */}
            {oneEvent?.roomKind?.length == 0 ? null : (
              <div className="table-ep ">
                <div
                  className="header-custom-table"
                  style={{ cursor: "pointer", background: "#C7363D" }}
                >
                  <span>Tipovi soba</span>
                  <span className="last-c">Popunjenost</span>
                </div>

                <div className="custom-table-body">
                  <div className="row-c-t">
                    <span>Ukupan broj tipova soba</span>
                    <span className="text-row-2">
                      {oneEvent?.roomKind.reduce(
                        (accumulator: number, currentValue: RoomKindDto) =>
                          accumulator + currentValue.totalNumber,
                        0
                      )}
                    </span>
                    {/* <div>
                          <Tooltip
                            className="progress"
                            title={`${Full} Popunjeno / ${Reserved} Rezervisano / ${Free} Slobodno`}
                          >
                            <div className="progress-bar-ep">
                              <Progress
                                percent={
                                  +(
                                    (Reserved / (Full + Reserved + Free)) *
                                      100 +
                                    (Full / (Full + Reserved + Free)) * 100
                                  ).toFixed(2)
                                }
                                success={{
                                  percent:
                                    (Full / (Full + Reserved + Free)) * 100,
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div> */}
                  </div>
                  <div className="row-roomType">
                    {oneEvent?.roomKind?.map((roomKind: RoomKindDto) => {
                      let totalNumber = roomKind?.totalNumber;
                      let Full = roomKind?.usedNumber; /// popunjeno
                      let Free = totalNumber - Full; /// slobodno

                      return (
                        <div className="row-c-t">
                          <span className="text-row">{roomKind?.name}</span>
                          <span className="text-row-2">
                            <p style={{ color: "#C7363D" }}>{Full}/</p>
                            <p style={{ color: "#52C41A" }}>{Free}/</p>
                            <p style={{ color: "#000" }}>
                              {roomKind?.totalNumber}
                            </p>
                          </span>
                          <div>
                            <Tooltip
                              className="progress"
                              title={`${Full} Popunjeno  / ${Free} Slobodno`}
                            >
                              <div className="progress-bar-ep">
                                <Progress
                                  percent={parseFloat(
                                    ((Full / totalNumber) * 100).toFixed(2)
                                  )}
                                  success={{
                                    percent: (Full / (Full + Free)) * 100,
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="footer-ep">
            <div className="first-column-f">
              {/* <p>Legenda:</p>
              <span style={{ color: "#52C41A" }}>
                {" "}
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.7418 10C11.7418 10.1182 11.7185 10.2352 11.6733 10.3444C11.6281 10.4536 11.5618 10.5528 11.4782 10.6364C11.3946 10.72 11.2954 10.7863 11.1862 10.8315C11.077 10.8767 10.96 10.9 10.8418 10.9C10.7236 10.9 10.6066 10.8767 10.4974 10.8315C10.3882 10.7863 10.289 10.72 10.2054 10.6364C10.1219 10.5528 10.0556 10.4536 10.0103 10.3444C9.9651 10.2352 9.94182 10.1182 9.94182 10C9.94182 9.76133 10.0366 9.53241 10.2054 9.36363C10.3742 9.19484 10.6031 9.10002 10.8418 9.10002C11.0805 9.10002 11.3094 9.19484 11.4782 9.36363C11.647 9.53241 11.7418 9.76133 11.7418 10ZM8.28342 0.416822C8.19601 0.398047 8.10551 0.399043 8.01854 0.419738C7.93156 0.440432 7.85031 0.480301 7.78073 0.536431C7.71114 0.592561 7.65497 0.663532 7.61634 0.744156C7.5777 0.82478 7.55757 0.913019 7.55742 1.00242V19.0024C7.5574 19.0919 7.57739 19.1803 7.61595 19.2611C7.65451 19.3418 7.71065 19.413 7.78026 19.4692C7.84987 19.5255 7.93118 19.5655 8.01825 19.5862C8.10531 19.607 8.19591 19.608 8.28342 19.5892L16.6834 17.788C16.8176 17.7589 16.9378 17.6847 17.0238 17.5776C17.1099 17.4706 17.1566 17.3373 17.1562 17.2V2.80002C17.156 2.66295 17.1088 2.53009 17.0226 2.42355C16.9364 2.31701 16.8162 2.24321 16.6822 2.21442L8.28222 0.415622L8.28342 0.416822ZM8.75742 18.2596V1.74402L15.9574 3.28602V16.7164L8.75742 18.2596ZM6.35982 18.3976V17.1976H1.55742V2.80362H6.35982V1.60362H0.957422C0.798292 1.60362 0.64568 1.66684 0.533158 1.77936C0.420636 1.89188 0.357422 2.04449 0.357422 2.20362V17.7976C0.357422 17.9568 0.420636 18.1094 0.533158 18.2219C0.64568 18.3344 0.798292 18.3976 0.957422 18.3976H6.35982Z"
                    fill="#52C41A"
                  />
                </svg>
                Slobodno{" "}
              </span>
              <span style={{ color: "#FABC29" }}>
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5543 12C15.5543 12.1182 15.531 12.2352 15.4858 12.3444C15.4406 12.4536 15.3743 12.5528 15.2907 12.6364C15.2071 12.72 15.1079 12.7863 14.9987 12.8315C14.8895 12.8767 14.7725 12.9 14.6543 12.9C14.5361 12.9 14.4191 12.8767 14.3099 12.8315C14.2007 12.7863 14.1015 12.72 14.0179 12.6364C13.9344 12.5528 13.8681 12.4536 13.8228 12.3444C13.7776 12.2352 13.7543 12.1182 13.7543 12C13.7543 11.7613 13.8491 11.5324 14.0179 11.3636C14.1867 11.1948 14.4156 11.1 14.6543 11.1C14.893 11.1 15.1219 11.1948 15.2907 11.3636C15.4595 11.5324 15.5543 11.7613 15.5543 12ZM12.0959 2.41682C12.0085 2.39805 11.918 2.39904 11.831 2.41974C11.7441 2.44043 11.6628 2.4803 11.5932 2.53643C11.5236 2.59256 11.4675 2.66353 11.4288 2.74416C11.3902 2.82478 11.3701 2.91302 11.3699 3.00242V21.0024C11.3699 21.0919 11.3899 21.1803 11.4285 21.2611C11.467 21.3418 11.5231 21.413 11.5928 21.4692C11.6624 21.5255 11.7437 21.5655 11.8307 21.5862C11.9178 21.607 12.0084 21.608 12.0959 21.5892L20.4959 19.788C20.6301 19.7589 20.7503 19.6847 20.8363 19.5776C20.9224 19.4706 20.9691 19.3373 20.9687 19.2V4.80002C20.9685 4.66295 20.9213 4.53009 20.8351 4.42355C20.7489 4.31701 20.6287 4.24321 20.4947 4.21442L12.0947 2.41562L12.0959 2.41682ZM12.5699 20.2596V3.74402L19.7699 5.28602V18.7164L12.5699 20.2596ZM10.1723 20.3976V19.1976H5.36992V4.80362H10.1723V3.60362H4.76992C4.61079 3.60362 4.45818 3.66684 4.34566 3.77936C4.23314 3.89188 4.16992 4.04449 4.16992 4.20362V19.7976C4.16992 19.9568 4.23314 20.1094 4.34566 20.2219C4.45818 20.3344 4.61079 20.3976 4.76992 20.3976H10.1723Z"
                    fill="#FABC29"
                  />
                </svg>
                Rezervisano
              </span>
              <span style={{ color: "#C7363D" }}>
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.3668 10C12.3668 10.1182 12.3435 10.2352 12.2983 10.3444C12.2531 10.4536 12.1868 10.5528 12.1032 10.6364C12.0196 10.72 11.9204 10.7863 11.8112 10.8315C11.702 10.8767 11.585 10.9 11.4668 10.9C11.3486 10.9 11.2316 10.8767 11.1224 10.8315C11.0132 10.7863 10.914 10.72 10.8304 10.6364C10.7469 10.5528 10.6806 10.4536 10.6353 10.3444C10.5901 10.2352 10.5668 10.1182 10.5668 10C10.5668 9.76133 10.6616 9.53241 10.8304 9.36363C10.9992 9.19484 11.2281 9.10002 11.4668 9.10002C11.7055 9.10002 11.9344 9.19484 12.1032 9.36363C12.272 9.53241 12.3668 9.76133 12.3668 10ZM8.90842 0.416822C8.82101 0.398047 8.73051 0.399043 8.64354 0.419738C8.55656 0.440432 8.47531 0.480301 8.40573 0.536431C8.33614 0.592561 8.27997 0.663532 8.24134 0.744156C8.2027 0.82478 8.18257 0.913019 8.18242 1.00242V19.0024C8.1824 19.0919 8.20239 19.1803 8.24095 19.2611C8.27951 19.3418 8.33565 19.413 8.40526 19.4692C8.47487 19.5255 8.55618 19.5655 8.64325 19.5862C8.73031 19.607 8.82091 19.608 8.90842 19.5892L17.3084 17.788C17.4426 17.7589 17.5628 17.6847 17.6488 17.5776C17.7349 17.4706 17.7816 17.3373 17.7812 17.2V2.80002C17.781 2.66295 17.7338 2.53009 17.6476 2.42355C17.5614 2.31701 17.4412 2.24321 17.3072 2.21442L8.90722 0.415622L8.90842 0.416822ZM9.38242 18.2596V1.74402L16.5824 3.28602V16.7164L9.38242 18.2596ZM6.98482 18.3976V17.1976H2.18242V2.80362H6.98482V1.60362H1.58242C1.42329 1.60362 1.27068 1.66684 1.15816 1.77936C1.04564 1.89188 0.982422 2.04449 0.982422 2.20362V17.7976C0.982422 17.9568 1.04564 18.1094 1.15816 18.2219C1.27068 18.3344 1.42329 18.3976 1.58242 18.3976H6.98482Z"
                    fill="#C7363D"
                  />
                </svg>
                Popunjeno
              </span> */}
            </div>
            <div className="last-column-f">
              {/* <Button type="primary" htmlType="submit">
                E-mail obaveštenje
              </Button>
              <Button type="primary" htmlType="submit">
                Export
              </Button> */}
            </div>
          </div>
        </div>
      </Spin>
    </PageLayout>
  );
};

export default EventOverviewPage;
